import EnumService from '../EnumService'

export default class EtniaEnumService extends EnumService{

    constructor(){
        super('enumEtnia');
    }
  
  }